import React from "react";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

const CounterSection = () => {
  const { ref, inView } = useInView({ triggerOnce: true });

  // Responsive styles
  const containerStyle = {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    alignItems: "center",
    backgroundColor: "whitesmoke",
    padding: "55px",
    color: "#ff7043",
    fontSize:'2.2rem',
    fontWeight:'700',
  };

  const boxStyle = {
    flex: "1 1 20%",
    textAlign: "center",
    margin: "20px",
    boxSizing: "border-box",
  };

  const textStyle = {
    marginTop: "10px",
    fontSize: "22px",
    fontWeight: "bold",
    color: "#151517",
  };

  const isSmallScreen = window.innerWidth <= 768;
  const isExtraSmallScreen = window.innerWidth <= 576;

  if (isSmallScreen) {
    boxStyle.flex = "1 1 50%";
  }
  if (isExtraSmallScreen) {
    boxStyle.flex = "1 1 100%";
  }

  return (
    <div style={containerStyle} ref={ref}>
      <div style={boxStyle}>
        {inView && <CountUp start={1} end={560} duration={5} />}
        <p style={textStyle}>Happy Clients</p>
      </div>
      <div style={boxStyle}>
        {inView && <CountUp start={1} end={60} duration={5} />}
        <p style={textStyle}>Hard Worker</p>
      </div>
      <div style={boxStyle}>
        {inView && <CountUp start={1} end={332} duration={5} />} 
        <p style={textStyle}>Complete Project</p>
      </div>
      <div style={boxStyle}>
        {inView && <CountUp start={1} end={9} duration={5} />}
        <p style={textStyle}>Years Of Experience</p>
      </div>
    </div>
  );
};

export default CounterSection;
